<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12">
        <DataTable
          :headers="headers"
          :items="itemsListSale"
          title="Listado de ventas"
        />
      </v-col>
    </v-row>
  </v-container>
 <!--  <div>
    <v-card
      flat
      style="border-radius:0px"
      class="my-1 d-flex"
    >
      <span class="weight-l">
        Listado de ventas
      </span>
      <v-card-text>

        <v-data-table
          :headers="headers"
          :items="itemsListSale"
          class="elevation-0"
        >
          <template v-slot:item.title_b2b="{ item }">
            <v-list-item two-line>
              <v-list-item-content>
                <v-list-item-title>{{ item.title_b2b }}</v-list-item-title>
                <v-list-item-subtitle>{{ item.title_ml }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          
        </v-data-table>

        <v-row>
          <v-col xs="12" sm="12" md="4">
            <v-btn icon color="indigo">
              <v-icon>mdi-point-of-sale</v-icon>
            </v-btn>
            <span>Numero de venta:</span>
            <span class="font-weight-bold ml-2">( {{ item.sale_id }} )</span>
            <br />
            <br />
            <v-btn icon color="indigo">
              <v-icon>mdi-receipt</v-icon>
            </v-btn>
            <span>Factura asociada:</span>
            <span class="font-weight-bold ml-2">( {{ item.bill_number }} )</span>
          </v-col>
          <v-col xs="12" sm="12" md="4">
            <v-btn icon color="indigo">
              <v-icon>mdi-subtitles</v-icon>
            </v-btn>
            <span>Titulo:</span>
            <span class="font-weight-bold ml-2">( {{ item.sale_id }} )</span>
            <br />
            <br />
            <v-btn icon color="indigo">
              <v-icon>mdi-source-branch</v-icon>
            </v-btn>
            <span>Marca/Modelo:</span>
            <span class="font-weight-bold ml-2">( {{ item.sale_id }} )</span>
          </v-col>
          <v-col xs="12" sm="12" md="4">
            <v-btn icon color="indigo">
              <v-icon>mdi-code-tags-check</v-icon>
            </v-btn>
            <span>Estatus del paquete:</span>
            <span class="font-weight-bold ml-2">( {{ item.status }} )</span>
            <br />
            <br />
            <v-btn icon color="indigo">
              <v-icon>mdi-send</v-icon>
            </v-btn>
            <span>Estatus del envio:</span>
            <span class="font-weight-bold ml-2">( {{ item.status }} )</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
    </v-card>
  </div> -->
</template>

<script>
  import DataTable from "./../Dashboard/Layout/Utils/DataTable.vue";
export default {
  components: {
    // Title,
    // News,
    // NewsIncome,
    DataTable
  },

  data() {
    return {
      headers: [
        {
          text: "N° de venta",
          value: "sale_id",
          width: "130",
          class: "length_text black--text",
        },
        {
          text: "Factura",
          value: "bill_number",
          width: "140",
          class: "length_text black--text",
        },
        {
          text: "Titulo",
          value: "title_b2b",
          width: "150",
          class: "length_text black--text",
        },
        {
          text: "Marca/Modelo",
          value: "brand",
          width: "140",
          class: "length_text black--text",
        },
        {
          text: "Estatus del paquete",
          value: "package_status",
          width: "180",
          class: "length_text black--text",
        },
        {
          text: "Estatus del envio",
          value: "shipping_status",
          width: "180",
          class: "length_text black--text",
        }
      ],
      data: []
    };
  },

  created() {
    this.getListDropshipping();
  },

  computed: {
    itemsListSale() {
      return this.$store.getters["dropshipping/ITEMS_LIST_SALES"];
    }
  },

  methods: {
    async getListDropshipping() {
      try {
        const response = await this.$store.dispatch(
          "dropshipping/LIST_DROPSHIPPING"
        );
        // this.data = response.data.data;
        console.log(response.data.data);
      } catch (error) {
        console.log(error);
      }
    },
    textColor(item) {
      if (item == "Disponibilidad Normal") {
        return "font-text-12  bg-green";
      } else if (item == "Disponibilidad Baja") {
        return "font-text-12  bg-yellow";
      } else if (item == "No Disponible") {
        return "font-text-12  bg-red";
      } else {
        return "font-text-12 bg-pink";
      }
    },
    PVC(pvc, discount, count) {
      let pvc_total_product = 0;
      let pvc_total = 0;
      if (count > 0) {
        let data_product = discount[count - 1];

        let discount_product =
          data_product == undefined ? 0 : data_product.discount;

        pvc_total_product = pvc - (pvc * discount_product) / 100;

        pvc_total =
          pvc_total_product - pvc_total_product * (discount_product / 100);
      } else {
        pvc_total = pvc;
      }
      return pvc_total;
    }
  }
};
</script>

<style>
</style>